module.exports = __webpack_public_path__ + "img/icon_shared.a46e4bcd.svg";